import React from "react";
import Container from "@ui/container";

const DetailsLink = ({ data }) => {
    if (!data || !data.text) return null;

    return (
        <a href={data.url} className="text-xs text-skin-primary">
            {data.text}
        </a>
    );
};

const LeftSection = ({ data }) => {
    return (
        <div className="flex flex-row gap-3">
            <div className="max-w-[102px] min-w-[82px]">
                <img
                    className="w-full rounded-md"
                    src={data.imageUrl}
                    alt={data.title}
                />
            </div>
            <div className="text-sm">
                <h2 className="text-sm font-semibold text-skin-dark md:text-base">
                    {data.title}
                </h2>
                <div>
                    <span className="font-semibold">{data.price}</span>{" "}
                    {data.priceDesc}
                </div>
                <DetailsLink data={data.detailsLink} />
            </div>
        </div>
    );
};

const RightSection = ({ data }) => {
    return (
        <div className="hidden md:block">
            <p className="text-right font-semibold text-skin-dark md:text-base">
                {data.rightText}
            </p>
            <span className="text-sm text-skin-light">{data.rightSubText}</span>
        </div>
    );
};

const ItemShortSummary = ({ data }) => {
    return (
        <div className="flex justify-between gap-3">
            <LeftSection data={data} />
            <RightSection data={data} />
        </div>
    );
};

export default ItemShortSummary;
